import { render } from "./totalqueries.vue?vue&type=template&id=3077e614"
import script from "./totalqueries.vue?vue&type=script&lang=js"
export * from "./totalqueries.vue?vue&type=script&lang=js"

import "./totalqueries.vue?vue&type=style&index=0&id=3077e614&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__